<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          dense
          multi-sort
          :headers="tableHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          show-expand
          :expanded.sync="expanded"
          :single-expand="true"
          @item-expanded="loadDetails"
          item-key="_id"
          :class="{ 'table-cell-wrap': wrap, 'table-cell-no-wrap': !wrap }">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Markere</v-toolbar-title>
              <v-btn icon @click="refresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon @click="toggleWrap">
                <v-icon>{{ wrap ? 'mdi-wrap-disabled' :'mdi-wrap'}}</v-icon>
              </v-btn>
              <v-divider vertical class="mx-4" inset></v-divider>
              <v-text-field
                v-model="search"
                label="Cautare"
                class="mx-4"
                clearable
                placeholder="address, unique, unique_apl, status"
                hide-details
                persistent-hint>
              </v-text-field>
              <v-spacer></v-spacer>
              <v-select
                :items="aplsFilterItems"
                item-text="name"
                item-value="_id"
                label="APL"
                v-model="selectedAPL"
                hide-details>
              </v-select>
              <v-spacer></v-spacer>
              <v-select
                :items="categoriesFilterItems"
                item-text="value"
                item-value="_id"
                label="Categorie"
                v-model="selectedCategory"
                hide-details>
              </v-select>
              <v-spacer></v-spacer>
              <v-select
                :items="statusesFilterItems"
                item-text="value"
                item-value="_id"
                label="Status"
                v-model="selectedStatus"
                hide-details>
              </v-select>
              <v-spacer></v-spacer>
              <v-select
                :items="availabilityFilterItems"
                item-text="label"
                item-value="_id"
                label="Availability"
                v-model="selectedAvailability"
                hide-details>
              </v-select>
              <v-spacer></v-spacer>
              <v-btn icon @click="download">
                <v-icon
                  color="primary"
                  title="export conform filtrelor">
                  mdi-download
                </v-icon>
              </v-btn>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    dark
                    v-on="on"
                    icon>
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <v-list dense flat>
                  <v-list-item-group v-model="selectedHeaders" multiple>
                    <v-list-item
                      v-for="head in headers"
                      :key="head.value"
                      :value="head.text">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title v-text="head.text"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon small :color="active ? 'primary' : 'error'">{{ active ? 'mdi-check' : 'mdi-close' }}</v-icon>
                        </v-list-item-icon>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-toolbar>
          </template>
          <template v-slot:item.status_id.icon.url="{ item }">
            <v-img
              :src="getIcon(item.status_id ? item.status_id.icon : null)"
              lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA8CAYAAAA34qk1AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAABvpJREFUeJzNm3lsFFUcgGk5yiVdSkHlCEVAbkGDRyISjXIokSMEPEA5REQxIooma0NQrGIoBiVexPgHChiCIphQUMQoaGUhHI0BkUNAwilIodgWKMXvx77VYZk38+bt0PJLvjQtM+/9vp1371CjRhVGLLa+HtwCUfgKYvATLITnoTtkVmVOoQbJ14TblVQZXNBQDjsgHzpCWnXnbhwk2wCmwt8egm6chMXQq7odfIMk68BLUBpQ0skRmAmR6vbRBsn1heMpSCaohGXQtVqFonlv13X7u0ouVUmn7Ga4t6r9RLALzIKhLpKtfQYeW3bDoKoS7ABvw3Z4Axq4iEYDJH8W9sEmKIID6gnqrt8LA6+kYCZMg1NQCs/oriWR7w2a4jp4ArJc7m8CY2AplLjc/xd0vxKSHWEzXFCSYyDdQ/SAh6QkPglqmdTNdfXhVdjv0oxbhCWYDg/DSSV5Bib4SGZ4ND2ZT3vb5MJ9jWFGLD7HJspbLR+EvWGNi5IZ8CZUKMlK1XQ9nwQVt9FIloXRtyijB/ziKPe1mO0qCpnGMF8JJpgL9QwS6aoRnW2d0OV1yLp5FlSoD/CuwIUgkwWLkyQPQ2vDJDq4SB6TJx04Ge96ZA09IRZfIxdI0za+GZlGMC9JUprsuAAJRFxEZRTW9mvbkBYCD8FpGG10EzK1IS9JUtgCDQMmUJwk+paNSID6JsMauN73YmTGq1HVKSm/P2hRcaFDUvrRWCsD8/rSVTPu63khMs1gj8vT3CoLBYuK5zhEpVkNtrYIVq/33IzM+y6SQp5lhXc75lJpxv2tMg8zkGkLJS6S5XCrTZlqRNzvEO0Xdt6BA5mPNE/zT2nStuUi96Gj6VbNjkMXiNSHoxpRGW1r25aNXB/4B87BqDDyzcldnQERaArZkAn+OSIySiMprEklKbV6maee6is2ZSBRHzrDJFgCm2A77IZd8BtsgE9gKDSHy+drlxWQk59TEVWyveEUfBxQsBk8BxuhGM4acAb2QR5cOp+qzbNO9Neo5pgkgKgckL0LP5qsc0kwC6bAH4ZyOuQDausUPe0hegRapSKqZOWMdlXMZYPtEKwNg1WzTEXQyU5olRCt9BCVf3syBFFZjw6BmzWSXWABlCY1w8OqL4r8ISi3kF0Hdf2eqFAkW7YQZOUgu2eSYLoaQLbAXlgEuTAM7oBO0A7aQEforfrtcigJ0G8n+vVRQTbdr0PNEGT/mwZUUx0LM+FRJWV0UsB1jVUzLzKU3Syin/qICnIY9lQYso5kM9XTshrsuC9NPeUCA9EyEe0F5w1k5cxoCjQKSzaMQKK16oeesonDr5UGoonTv29gJGSbJMJ1adAUekYNjmEsZXvBMU9RlUyWWteayDr3qYWQDxNhBAyHR6Lxfe10WAI7oQC6OZOLrHiveciyi3xFlWx7C1k/1sMAt8QQvR9uCFF0hNdIfMnFJNVOffomfdaLmHqy2pUQku0hD+qEJCoD2w4jUSUrffYeWAonAshJa/gAjL7aQ7AhFEEoG3JkankMSmWeN5N0Heih+p/0OTkd/BIWReMnEpOhH1j1NyQLoBCutbJLCoS+1YiuD6N860BwDlyACWGUh9BqjWh+GOVbB4IvK9GNqY7COfEN+QbNEvDGsHK2CuTGwnkl+1gqZSHTVjMYpXR4EEogNwxKleiKVMpCaBCcSJKU3VDVvwqQHMgNgdNKVH5q96t+gdB0l6e5PMx8rQOx4VCmRIXHbcpRU8t3SZKyJOzmeSMV3gShfvOlqWeco48KC2zKUf3zkENSNugzTBLoA8sgx6Zi06D8aQ5JYUvQMtR2LTfpaa4C/6/81aplPnwNRruUoEG5abA4SbQ4aDk58ePNXQ7JbWD+7QKV9oQj8AO0DJqAQfnZsCdJVLjsVR5d5MSPYmY7JPfIli1oIjUhFyqlSUm/DWzjXf7opP6ZwHg5iNRtcFxJHoD+0pRtkrkOtqsEDsIAMHplxqfcFrDLRVJoalJGTvwoplBJiuyAHLcT+gBJ3QclKgn5OQv8v1XWlyf9f4lGUp6w7/coajp5QY2uB2FgSpIqsXQY75jvpCnvVnvJ9gHL6gQrNU32YqvxK0P1yxFqnpTdSg+r5qpJMANmQIUjqQrV/N6B/qA9NJMWAM/C7+qDcpMU1vpIylTSF7bCXBlxQxFMSvYa+ELzNIoj8U30Z2punAhPw1Q1TW2Fcg/BBLN9RGVhsBBGQqCXR4LKtoKlHk0vVe70Ec1Wslf+XXuSaQmfw7mQJbdFQhjRQ41IfLLPj/y/80gV6bcvVreXNkjuATgagqhMN1fvfw6QIMEmsCBy6YgcBDkcM3rH8KoIku0MK+CsoaAMaAsjIZ0AVnmQePNIfFpZq+nD8rdVMBBCfwlSF/8C3QjwwqUt65wAAAAASUVORK5CYII="
              height="40"
              max-width="80"
              contain>
            </v-img>
          </template>
          <template v-slot:item.status_id.icon.scale="{ item }">
            {{ item.status_id ? item.status_id.icon.scale : 'no status found (2 by default)'}}
          </template>
          <template v-slot:item.availability="{ item }">
            {{ item.availability === 0 ? 'Ascuns' : item.availability === 1 ? 'Vizibil' : 'Sters' }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="white-space: nowrap">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                color="accent">
                mdi-pencil
              </v-icon>
              <v-icon
              class="mr-2"
                small
                @click="deleteItem(item)"
                color="error">
                mdi-delete
              </v-icon>
            </div>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
          </template>

          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length">
              <v-card elevation="0" class="my-2 mx-1" :loading="propertiesLoading">
                <v-card-text>

                  <v-tabs vertical>
                    <v-tab v-for="group in properties" :key="group._id">
                      <v-img
                        :src="getIcon(group.icon)"
                        height="20"
                        max-width="40"
                        contain
                        v-if="group.icon.url">
                      </v-img>
                      {{ group.label }}
                    </v-tab>

                    <v-tab-item v-for="group in properties" :key="group._id">
                      <v-card flat>
                        <v-card-text class="pa-0">
                          <div>{{ group.info }}</div>
                          <v-expansion-panels multiple flat accordion :value="expandedPanels(group)">
                            <v-expansion-panel v-for="prop in group.properties" :key="prop._id">
                              <v-expansion-panel-header class="pa-0">
                                <v-img
                                  :src="getIcon(prop.icon)"
                                  height="20"
                                  width="40"
                                  style="flex-grow: 0"
                                  contain
                                  v-if="prop.icon.url">
                                </v-img>
                                {{ prop.label }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div class="caption">
                                  <em>{{ prop.info }}</em>
                                  <div>
                                    <template v-if="prop.type === 'image'">
                                      <template v-if="details[group.label][prop.label]">
                                        <v-img
                                          :src="SERVER_URLC + details[group.label][prop.label] + '?' + new Date().getTime()"
                                          max-height="100"
                                          contain
                                          v-if="details[group.label][prop.label]">
                                        </v-img>
                                        <a :href="details[group.label][prop.label]" download target="_blank">
                                          <v-icon>mdi-download</v-icon>
                                        </a>
                                      </template>
                                      <span v-else> - </span>
                                    </template>
                                    <template v-else-if="prop.type === 'document'">
                                      <a :href="details[group.label][prop.label]" v-if="details[group.label][prop.label]" download target="_blank">
                                        <v-icon>mdi-download</v-icon>
                                      </a>
                                      <span v-else> - </span>
                                    </template>
                                    <template v-else>
                                      {{ details[group.label][prop.label] }}
                                    </template>
                                  </div>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="openEditItemProps">
                    <v-icon color="accent">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-btn
      color="primary"
      fab
      bottom
      right
      class="avz-fab"
      @click="openItemDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- item form -->
    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="75vw">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Adaugare' : 'Modificare' }} Marker</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-select
              :items="apls"
              item-text="name"
              item-value="_id"
              label="APL"
              :rules="required"
              v-model="item.apl_id"
              @change="aplChanged">
            </v-select>

            <v-text-field
              v-model="item.unique_apl"
              label="Cod unic APL"
              hint="Cod unic APL"
              required
              :rules="required"
              disabled>
            </v-text-field>

            <v-select
              :items="statusesForAPL"
              item-text="value"
              item-value="_id"
              label="Status"
              :rules="required"
              v-model="item.status_id"
              @change="statusChanged">
            </v-select>

            <v-select
              :items="categoriesForAPL"
              item-text="value"
              item-value="_id"
              label="Categorie"
              :rules="required"
              v-model="item.category_id"
              @change="categoryChanged">
            </v-select>

            <v-text-field
              v-model="item.unique"
              label="Cod unic"
              hint="Cod unic marker in xls(s); de ex nr. crt."
              required
              :rules="required">
            </v-text-field>

            <v-text-field
              v-model="item.address"
              label="Adresa"
              hint="Adresa marker"
              required
              :rules="required">
            </v-text-field>

            <v-select
              :items="availabilityItems"
              item-text="label"
              item-value="_id"
              label="Availability"
              :rules="required"
              v-model="item.availability">
              <template v-slot:item="data">
                <v-list-item-icon>
                  <v-icon small>
                    {{data.item.icon}}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{data.item.label}}</v-list-item-content>
              </template>
            </v-select>

            <v-text-field
              v-model.number="item.lat"
              label="Latitudine"
              hint="Latitudine"
              required
              :rules="required">
            </v-text-field>
            <v-text-field
              v-model.number="item.lng"
              label="Longitudine"
              hint="Longitudine"
              required
              :rules="required">
            </v-text-field>

            <GmapMap
              v-if="item.lat && item.lng"
              :center="{ lat: item.lat, lng: item.lng }"
              :zoom="11"
              map-type-id="roadmap"
              style="width: 100%; height: 50vh"
              :options="{styles: mapStyles}">
              <GmapMarker
                draggable
                @dragend="markerDragged"
                :position="{ lat: item.lat, lng: item.lng }"
                :clickable="true"
                :icon="{
                  url: getIconFromStatusId(),
                  scaledSize: { width: 40, height: 60 },
                  origin: { x: 0, y: 0 },
                  anchor: { x: 40 / 2, y: 60 }
                }"
              />
              <GmapPolygon :paths="decodePath" :options="polyOptions" :editable="false" />
            </GmapMap>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Inchide</v-btn>
          <v-btn color="primary" @click="saveItem">Salveaza Status</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmati stergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anuleaza stergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Sterge Marker</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- export dialog -->
    <v-dialog
      persistent
      scrollable
      v-model="exportMarkersDialog"
      width="75vw">
      <v-card max-height="75vh">
        <v-card-title>Alegeti coloanele pentru export {{ exportMarkers.length }} markere din {{ selectedAPLName }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list flat>
            <v-list-item-group multiple v-model="selectedMarkerKeys">
              <v-list-item v-for="key in markerKeys" :key="key" :value="key">
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" @click="toggle"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ key }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeExportMarkers">Anuleaza export</v-btn>
          <v-btn color="primary" @click="confirmExportMarkers">Executa export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- edit item properties dialog -->
    <v-dialog
      persistent
      scrollable
      v-model="editItemPropsDialog"
      width="75vw">
      <v-card max-height="75vh" v-if="expandedItem && detailedItem.marker_id">
        <v-card-title>
          <div>
            Editare proprietati marker {{expandedItem.unique}} - {{expandedItem.address}}, {{expandedItem.apl_id.name}}, {{expandedItem.apl_id.county}}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="closeEditItemProps">
            <v-icon small color="error">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs vertical>
            <v-tab v-for="group in properties" :key="group._id">
              <v-img
                :src="getIcon(group.icon)"
                height="20"
                max-width="40"
                contain
                v-if="group.icon.url">
              </v-img>
              {{ group.label }}
            </v-tab>

            <v-tab-item v-for="group in properties" :key="group._id">
              <v-card flat>
                <v-card-text>
                  <div>{{ group.info }}</div>

                  <div v-for="prop in group.properties" :key="prop._id">
                    <template v-if="prop.type === 'short text'">
                      <v-text-field
                        v-model="detailedItem[group.label][prop.label].value"
                        :label="prop.label"
                        persistent-hint
                        :hint="prop.info">
                        <template v-slot:prepend-inner>
                          <v-img
                            :src="getIcon(prop.icon ? prop.icon : null)"
                            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA8CAYAAAA34qk1AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAABvpJREFUeJzNm3lsFFUcgGk5yiVdSkHlCEVAbkGDRyISjXIokSMEPEA5REQxIooma0NQrGIoBiVexPgHChiCIphQUMQoaGUhHI0BkUNAwilIodgWKMXvx77VYZk38+bt0PJLvjQtM+/9vp1371CjRhVGLLa+HtwCUfgKYvATLITnoTtkVmVOoQbJ14TblVQZXNBQDjsgHzpCWnXnbhwk2wCmwt8egm6chMXQq7odfIMk68BLUBpQ0skRmAmR6vbRBsn1heMpSCaohGXQtVqFonlv13X7u0ouVUmn7Ga4t6r9RLALzIKhLpKtfQYeW3bDoKoS7ABvw3Z4Axq4iEYDJH8W9sEmKIID6gnqrt8LA6+kYCZMg1NQCs/oriWR7w2a4jp4ArJc7m8CY2AplLjc/xd0vxKSHWEzXFCSYyDdQ/SAh6QkPglqmdTNdfXhVdjv0oxbhCWYDg/DSSV5Bib4SGZ4ND2ZT3vb5MJ9jWFGLD7HJspbLR+EvWGNi5IZ8CZUKMlK1XQ9nwQVt9FIloXRtyijB/ziKPe1mO0qCpnGMF8JJpgL9QwS6aoRnW2d0OV1yLp5FlSoD/CuwIUgkwWLkyQPQ2vDJDq4SB6TJx04Ge96ZA09IRZfIxdI0za+GZlGMC9JUprsuAAJRFxEZRTW9mvbkBYCD8FpGG10EzK1IS9JUtgCDQMmUJwk+paNSID6JsMauN73YmTGq1HVKSm/P2hRcaFDUvrRWCsD8/rSVTPu63khMs1gj8vT3CoLBYuK5zhEpVkNtrYIVq/33IzM+y6SQp5lhXc75lJpxv2tMg8zkGkLJS6S5XCrTZlqRNzvEO0Xdt6BA5mPNE/zT2nStuUi96Gj6VbNjkMXiNSHoxpRGW1r25aNXB/4B87BqDDyzcldnQERaArZkAn+OSIySiMprEklKbV6maee6is2ZSBRHzrDJFgCm2A77IZd8BtsgE9gKDSHy+drlxWQk59TEVWyveEUfBxQsBk8BxuhGM4acAb2QR5cOp+qzbNO9Neo5pgkgKgckL0LP5qsc0kwC6bAH4ZyOuQDausUPe0hegRapSKqZOWMdlXMZYPtEKwNg1WzTEXQyU5olRCt9BCVf3syBFFZjw6BmzWSXWABlCY1w8OqL4r8ISi3kF0Hdf2eqFAkW7YQZOUgu2eSYLoaQLbAXlgEuTAM7oBO0A7aQEforfrtcigJ0G8n+vVRQTbdr0PNEGT/mwZUUx0LM+FRJWV0UsB1jVUzLzKU3Syin/qICnIY9lQYso5kM9XTshrsuC9NPeUCA9EyEe0F5w1k5cxoCjQKSzaMQKK16oeesonDr5UGoonTv29gJGSbJMJ1adAUekYNjmEsZXvBMU9RlUyWWteayDr3qYWQDxNhBAyHR6Lxfe10WAI7oQC6OZOLrHiveciyi3xFlWx7C1k/1sMAt8QQvR9uCFF0hNdIfMnFJNVOffomfdaLmHqy2pUQku0hD+qEJCoD2w4jUSUrffYeWAonAshJa/gAjL7aQ7AhFEEoG3JkankMSmWeN5N0Heih+p/0OTkd/BIWReMnEpOhH1j1NyQLoBCutbJLCoS+1YiuD6N860BwDlyACWGUh9BqjWh+GOVbB4IvK9GNqY7COfEN+QbNEvDGsHK2CuTGwnkl+1gqZSHTVjMYpXR4EEogNwxKleiKVMpCaBCcSJKU3VDVvwqQHMgNgdNKVH5q96t+gdB0l6e5PMx8rQOx4VCmRIXHbcpRU8t3SZKyJOzmeSMV3gShfvOlqWeco48KC2zKUf3zkENSNugzTBLoA8sgx6Zi06D8aQ5JYUvQMtR2LTfpaa4C/6/81aplPnwNRruUoEG5abA4SbQ4aDk58ePNXQ7JbWD+7QKV9oQj8AO0DJqAQfnZsCdJVLjsVR5d5MSPYmY7JPfIli1oIjUhFyqlSUm/DWzjXf7opP6ZwHg5iNRtcFxJHoD+0pRtkrkOtqsEDsIAMHplxqfcFrDLRVJoalJGTvwoplBJiuyAHLcT+gBJ3QclKgn5OQv8v1XWlyf9f4lGUp6w7/coajp5QY2uB2FgSpIqsXQY75jvpCnvVnvJ9gHL6gQrNU32YqvxK0P1yxFqnpTdSg+r5qpJMANmQIUjqQrV/N6B/qA9NJMWAM/C7+qDcpMU1vpIylTSF7bCXBlxQxFMSvYa+ELzNIoj8U30Z2punAhPw1Q1TW2Fcg/BBLN9RGVhsBBGQqCXR4LKtoKlHk0vVe70Ec1Wslf+XXuSaQmfw7mQJbdFQhjRQ41IfLLPj/y/80gV6bcvVreXNkjuATgagqhMN1fvfw6QIMEmsCBy6YgcBDkcM3rH8KoIku0MK+CsoaAMaAsjIZ0AVnmQePNIfFpZq+nD8rdVMBBCfwlSF/8C3QjwwqUt65wAAAAASUVORK5CYII="
                            height="20"
                            max-width="40"
                            contain>
                          </v-img>
                        </template>
                      </v-text-field>
                    </template>
                    <template v-if="prop.type === 'number'">
                      <v-text-field
                        v-model.number="detailedItem[group.label][prop.label].value"
                        type="number"
                        persistent-hint
                        :label="prop.label"
                        :hint="prop.info">
                        <template v-slot:prepend-inner>
                          <v-img
                            :src="getIcon(prop.icon ? prop.icon : null)"
                            lazy-src="data:image/png;base64,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"
                            height="20"
                            max-width="40"
                            contain>
                          </v-img>
                        </template>
                      </v-text-field>
                    </template>
                    <template v-if="prop.type === 'long text'">
                      <v-textarea
                        v-model="detailedItem[group.label][prop.label].value"
                        :label="prop.label"
                        persistent-hint
                        :hint="prop.info">
                        <template v-slot:prepend-inner>
                          <v-img
                            :src="getIcon(prop.icon ? prop.icon : null)"
                            lazy-src="data:image/png;base64,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"
                            height="20"
                            max-width="40"
                            contain>
                          </v-img>
                        </template>
                      </v-textarea>
                    </template>
                    <template v-if="prop.type === 'date'">
                      <v-menu
                        v-model="fieldMenus[prop._id]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="computedDateFormatted(detailedItem[group.label][prop.label].value)"
                            :label="prop.label"
                            :hint="prop.info"
                            persistent-hint

                            readonly
                            v-bind="attrs"
                            v-on="on">
                            <template v-slot:prepend-inner>
                              <v-img
                                :src="getIcon(prop.icon ? prop.icon : null)"
                                lazy-src="data:image/png;base64,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"
                                height="20"
                                max-width="40"
                                contain>
                              </v-img>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="detailedItem[group.label][prop.label].value" @input="fieldMenus[prop._id] = false"></v-date-picker>
                      </v-menu>
                    </template>
                    <template v-if="prop.type === 'time'">
                      <v-menu
                        v-model="fieldMenus[prop._id]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="detailedItem[group.label][prop.label].value"
                            :label="prop.label"
                            :hint="prop.info"
                            persistent-hint

                            readonly
                            v-bind="attrs"
                            v-on="on">
                            <template v-slot:prepend-inner>
                              <v-img
                                :src="getIcon(prop.icon ? prop.icon : null)"
                                lazy-src="data:image/png;base64,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"
                                height="20"
                                max-width="40"
                                contain>
                              </v-img>
                            </template>
                          </v-text-field>
                        </template>
                        <v-time-picker full-width v-model="detailedItem[group.label][prop.label].value" @input="fieldMenus[prop._id] = false"></v-time-picker>
                      </v-menu>
                    </template>
                    <template v-if="prop.type === 'image'">
                      <v-img
                        :src="detailedItem[group.label][prop.label].preview"
                        lazy-src="data:image/png;base64,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"
                        height="60"
                        position="center center"
                        contain
                        class="text-right">
                      </v-img>
                      <v-file-input
                        prepend-icon=""
                        v-model="detailedItem[group.label][prop.label].buffer"
                        @change="setPreview(group.label, prop.label)"
                        :label="prop.label"
                        persistent-hint
                        accept="image/*"
                        :hint="prop.info">
                        <template v-slot:prepend-inner>
                          <v-img
                            :src="getIcon(prop.icon ? prop.icon : null)"
                            lazy-src="data:image/png;base64,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"
                            height="20"
                            max-width="40"
                            contain>
                          </v-img>
                        </template>
                      </v-file-input>
                    </template>
                    <template v-if="prop.type === 'document'">
                      <v-file-input
                        prepend-icon=""
                        v-model="detailedItem[group.label][prop.label].buffer"
                        :label="prop.label"
                        persistent-hint
                        :hint="prop.info">
                        <template v-slot:prepend-inner>
                          <v-img
                            :src="getIcon(prop.icon ? prop.icon : null)"
                            lazy-src="data:image/png;base64,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"
                            height="20"
                            max-width="40"
                            contain>
                          </v-img>
                        </template>
                      </v-file-input>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeEditItemProps">Inchide</v-btn>
          <v-btn color="primary" @click="saveItemProps" :loading="saveDetailsLoading" :disabled="saveDetailsLoading">Salveaza datele</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'
import _debounce from 'lodash.debounce'
import mapStyles from '@/mapstyles/default.json'
import { gmapApi } from 'vue2-google-maps'
import flatten from 'flat'

import tableHeaders from '@/mixins/tableHeaders'

export default {
  name: 'avz-markers',
  mixins: [tableHeaders],
  data: () => ({
    mapStyles,
    expanded: [],
    selectedHeaders: ['id', 'apl', 'unique apl', 'unique', 'adresa', 'status', 'categorie', 'icon', 'icon scale', 'availability', 'lat', 'lng', 'creat', 'modificat', 'actions', 'expand'],
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'apl',
        value: 'apl_id.name',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'unique apl',
        value: 'unique_apl',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'unique',
        value: 'unique',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'denumire',
        value: 'name',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'adresa',
        value: 'address',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'status',
        value: 'status',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'categorie',
        value: 'category',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'icon',
        value: 'status_id.icon.url',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'icon scale',
        value: 'status_id.icon.scale',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'availability',
        value: 'availability',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'lat',
        value: 'lat',
        align: 'end',
        sortable: false,
        filterable: false
      },
      {
        text: 'lng',
        value: 'lng',
        align: 'end',
        sortable: false,
        filterable: false
      },
      {
        text: 'creat',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'modificat',
        value: 'updatedAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'actions',
        value: 'actions',
        sortable: false,
        filterable: false
      },
      {
        text: 'expand',
        value: 'data-table-expand'
      }
    ],
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    required: [val => (val !== null && val !== undefined) || 'Campul nu poate fi gol!'],
    item: {
      _id: null,
      apl_id: null,
      status_id: null,
      category_id: null,
      unique_apl: null,
      unique: null,
      status: null,
      category: null,
      availability: null,
      address: null,
      lat: null,
      lng: null
    },
    deleteItemDialog: false,
    deleteItemID: null,
    availabilityItems: [{
      _id: 0,
      label: 'Ascuns',
      icon: 'mdi-eye-off'
    }, {
      _id: 1,
      label: 'Vizibil',
      icon: 'mdi-eye'
    }, {
      _id: 2,
      label: 'Sters',
      icon: 'mdi-delete'
    }],
    availabilityFilterItems: [{
      _id: 0,
      label: 'Ascuns'
    }, {
      _id: 1,
      label: 'Vizibil'
    }, {
      _id: 2,
      label: 'Sters'
    }, {
      _id: null,
      label: 'Toate'
    }],

    exportMarkersDialog: false,
    selectedMarkerKeys: ['apl_id.name', 'unique_apl', 'unique', 'name', 'status', 'categorie', 'availability', 'address', 'lat', 'lng'],
    markerKeys: [],
    exportMarkers: [],

    apls: [],
    statuses: [],
    categories: [],

    properties: [],
    propertiesLoading: false,

    wrap: false,

    editItemPropsDialog: false,
    expandedItem: null,
    detailedItem: {},
    fieldMenus: {},
    saveDetailsLoading: false,
    details: {}
  }),

  computed: {
    google: gmapApi,
    items () {
      return this.$store.getters.markersItems
    },
    totalItems () {
      return this.$store.getters.markersTotal
    },
    loading () {
      return this.$store.getters.markersLoading
    },
    options: {
      get () {
        return this.$store.getters.markersOptions
      },
      set (value) {
        this.$store.dispatch('setMarkersOptions', value)
      }
    },
    search: {
      get () {
        return this.$store.getters.markersSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setMarkersSearch', value)
      }, 500)
    },
    tableHeaders () {
      return this.headers.filter(head => this.selectedHeaders.includes(head.text))
    },
    decodePath () {
      if (this.google) {
        if (this.item.apl_id) {
          if (typeof this.item.apl_id === 'string') {
            const apl = this.apls.find(apl => apl._id === this.item.apl_id)

            if (apl) {
              const poly = this.google.maps.geometry.encoding.decodePath(apl.borders.polyString)

              return poly
            } else {
              return []
            }
          } else if (typeof this.item.apl_id && typeof this.item.apl_id === 'object') {
            const poly = this.google.maps.geometry.encoding.decodePath(this.item.apl_id.borders.polyString)

            return poly
          } else {
            return []
          }
        } else {
          return []
        }
      } else {
        return []
      }
    },
    polyOptions () {
      let apl

      if (typeof this.item.apl_id === 'string') {
        apl = this.apls.find(apl => apl._id === this.item.apl_id)
      } else if (this.item.apl_id && typeof this.item.apl_id === 'object') {
        apl = this.item.apl_id
      }

      if (apl) {
        return {
          fillColor: apl.borders.fill,
          strokeColor: apl.borders.stroke
        }
      } else {
        return {}
      }
    },
    statusesForAPL () {
      if (this.item.apl_id) {
        return this.statuses.filter(status => status.apl_id === this.item.apl_id)
      } else {
        return []
      }
    },
    categoriesForAPL () {
      if (this.item.apl_id) {
        return this.categories.filter(category => category.apl_id === this.item.apl_id)
      } else {
        return []
      }
    },
    aplsFilterItems () {
      return this.apls.concat([{ _id: null, name: 'Toate' }])
    },
    statusesFilterItems () {
      if (this.selectedAPL) {
        return this.statuses
          .filter(status => {
            if (this.selectedCategory) {
              return status.apl_id === this.selectedAPL && status.category_id._id === this.selectedCategory
            }
            return status.apl_id === this.selectedAPL
          })
          .map(status => ({
            _id: status._id,
            value: `${status.category_id.value} - ${status.value}`
          }))
          .concat([{ _id: null, value: 'Toate' }])
      } else {
        return []
      }
    },
    categoriesFilterItems () {
      if (this.selectedAPL) {
        return this.categories.filter(category => category.apl_id === this.selectedAPL).concat([{ _id: null, value: 'Toate' }])
      } else {
        return []
      }
    },
    selectedAPL: {
      get () {
        return this.$store.getters.markersAPL
      },

      set (value) {
        this.selectedStatus = null
        this.$store.dispatch('setMarkersApl', value)
      }
    },
    selectedAPLName () {
      if (this.selectedAPL) {
        const apl = this.apls.find(apl => apl._id === this.selectedAPL)
        if (apl) return apl.name
        return 'Negasit'
      }
      return 'Toate APL-urile'
    },
    selectedStatus: {
      get () {
        return this.$store.getters.markersStatus
      },

      set (value) {
        this.$store.dispatch('setMarkersStatus', value)
      }
    },
    selectedCategory: {
      get () {
        return this.$store.getters.markersCategory
      },

      set (value) {
        this.$store.dispatch('setMarkersCategory', value)
      }
    },
    selectedAvailability: {
      get () {
        return this.$store.getters.markersAvailability
      },

      set (value) {
        this.$store.dispatch('setMarkersAvailability', value)
      }
    },
    computedDateFormatted () {
      return value => value ? (new Date(value)).toLocaleDateString('ro-RO', {}) : value
    },
    SERVER_URLC () {
      return SERVER_URL
    }
  },

  methods: {
    async saveItemProps () {
      this.saveDetailsLoading = true
      const details = await this.$store.dispatch('saveDetails', { data: this.detailedItem, properties: this.properties })
      this.properties.forEach(group => {
        this.$set(this.details, group.label, {})

        group.properties.forEach(prop => {
          if (prop.type === 'image' || prop.type === 'document') {
            // if (details && details[group.label] && details[group.label][prop.label]) {
            //   details[group.label][prop.label] = SERVER_URL + details[group.label][prop.label]
            // }
          }
          this.$set(this.details[group.label], prop.label, details && details[group.label] ? details[group.label][prop.label] : null)
        })
      })

      this.saveDetailsLoading = false
      this.closeEditItemProps()
      this.$forceUpdate()
    },
    openEditItemProps () {
      const details = this.details
      this.$set(this.detailedItem, '_id', details?._id ?? null)
      this.$set(this.detailedItem, 'marker_id', this.expandedItem._id)
      this.properties.forEach(group => {
        // this.detailedItem[group.label] = {}
        this.$set(this.detailedItem, group.label, {})

        group.properties.forEach(prop => {
          // this.detailedItem[group.label][prop.label] = {
          this.$set(this.detailedItem[group.label], prop.label, {
            type: prop.type,
            value: details && details[group.label] ? details[group.label][prop.label] : null
          })

          if (prop.type === 'image' || prop.type === 'document') {
            this.$set(this.detailedItem[group.label][prop.label], 'buffer', null)
            this.setPreview(group.label, prop.label)
          }
        })
      })
      this.editItemPropsDialog = true
    },
    closeEditItemProps () {
      this.editItemPropsDialog = false
      this.properties.forEach(group => {
        this.$set(this.detailedItem, group.label, {})

        group.properties.forEach(prop => {
          this.$set(this.detailedItem[group.label], prop.label, {
            type: prop.type,
            value: null
          })
          if (prop.type === 'image' || prop.type === 'document') {
            this.$set(this.detailedItem[group.label][prop.label], 'buffer', null)
          }
          if (prop.type === 'image') {
            this.setPreview(group.label, prop.label)
          }
        })
      })
    },
    toggleWrap () {
      this.wrap = !this.wrap
    },
    expandedPanels (group) {
      const a = []
      group.properties.forEach((p, i) => {
        if (p.expand) {
          a.push(i)
        }
      })

      return a
    },
    async loadDetails (e) {
      if (e.value) {
        try {
          this.propertiesLoading = true

          this.expandedItem = e.item

          const details = await this.$store.dispatch('fetchDetails', e.item._id)

          this.properties = await this.$store.dispatch('fetchProperties4Marker', e.item)

          this.$set(this.details, '_id', details?._id ?? null)
          this.$set(this.details, 'marker_id', this.expandedItem._id)
          this.properties.forEach(group => {
            this.$set(this.details, group.label, {})

            group.properties.forEach(prop => {
              if (prop.type === 'image' || prop.type === 'document') {
                if (details && details[group.label] && details[group.label][prop.label]) {
                  // details[group.label][prop.label] = SERVER_URL + details[group.label][prop.label]
                }
              }
              this.$set(this.details[group.label], prop.label, details && details[group.label] ? details[group.label][prop.label] : null)
            })
          })

          this.propertiesLoading = false
        } catch (err) {
          this.propertiesLoading = false
          console.log(err)
        }
      } else {
        this.expandedItem = null
        this.$nextTick(() => {
          this.details = {}
          this.detailedItem = {}
          this.properties = []
        })
      }
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
    },
    openItemDialog () {
      this.itemForm = true
      this.itemAction = 'add'
    },
    saveItem () {
      const valid = this.$refs.form.validate()
      if (valid) {
        const payload = Object.assign({}, this.item)
        this.$store.dispatch('saveMarker', payload)
        this.closeItemDialog()
      }
    },
    editItem (item) {
      this.item._id = item._id
      this.item.address = item.address
      this.item.apl_id = item.apl_id._id
      this.item.availability = item.availability
      this.item.lat = item.lat
      this.item.lng = item.lng
      this.item.status = item.status
      this.item.status_id = item.status_id?._id ?? null
      this.item.category = item.category
      this.item.category_id = item.category_id?._id ?? null
      this.item.unique = item.unique
      this.item.unique_apl = item.unique_apl

      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteMarker', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    getIcon (icon) {
      return SERVER_URL + (icon ? icon.url : '/statuses/apl-icon-orphan.png') + `?${new Date().getTime()}`
    },
    async setPreview (group, prop) {
      const value = this.detailedItem[group][prop].value
      const buffer = this.detailedItem[group][prop].buffer

      if (buffer instanceof File) {
        const base64 = await readFile(buffer)
        this.detailedItem[group][prop].preview = base64
      } else {
        if (typeof value === 'string') {
          this.detailedItem[group][prop].preview = SERVER_URL + value
        } else if (value === null || value === undefined) {
          this.detailedItem[group][prop].preview = SERVER_URL + '/statuses/apl-icon-orphan.png'
        }
      }

      this.$forceUpdate()
    },
    refresh () {
      this.$store.dispatch('fetchMarkers')
    },
    markerDragged ($event) {
      this.item.lat = $event.latLng.lat()
      this.item.lng = $event.latLng.lng()
    },
    getIconFromStatusId () {
      const status = this.statuses.find(status => status._id === this.item.status_id)

      if (status) {
        return SERVER_URL + status.icon.url
      } else {
        return SERVER_URL + '/statuses/apl-icon-orphan.png'
      }
    },

    aplChanged (aplId) {
      this.item.status_id = null
      this.item.status = null
      this.item.category_id = null
      this.item.category = null
      const apl = this.apls.find(apl => apl._id === aplId)
      this.item.unique_apl = apl.unique
      if (!this.item.lat && !this.item.lng) {
        this.item.lat = apl.center.lat
        this.item.lng = apl.center.lng
      }
    },
    statusChanged (statusId) {
      const status = this.statuses.find(status => status._id === statusId)
      this.item.status = status.value
    },
    categoryChanged (categoryId) {
      const category = this.categories.find(category => category._id === categoryId)
      this.item.category = category.value
    },

    async download () {
      try {
        const markers = await this.$store.dispatch('downloadMarkers')

        if (markers.length) {
          this.markerKeys = Object.keys(flatten(markers[0]))
          this.selectedMarkerKeys = ['apl_id.name', 'unique_apl', 'unique', 'status', 'category', 'availability', 'address', 'lat', 'lng']
          this.exportMarkers = Object.freeze(markers)
          this.exportMarkersDialog = true
        }
      } catch (err) {
        console.log(err)
      }
    },
    closeExportMarkers () {
      this.exportMarkersDialog = false
      this.markerKeys = []
      this.exportMarkers = []
    },
    confirmExportMarkers () {
      let table = `<thead><tr><th colspan="${this.selectedMarkerKeys.length}">Export ${this.selectedAPLName}<th></tr><tr><th></th></tr><tr>`

      this.selectedMarkerKeys.forEach(label => {
        table += `<th>${label}</th>`
      })
      table += '</tr></thead>'

      table += '<tbody>'
      this.exportMarkers.forEach((row, index) => {
        const flatRow = flatten(row)
        table += '<tr>'
        this.selectedMarkerKeys.forEach(key => {
          table += `<td>${flatRow[key] || ''}</td>`
        })
        table += '</tr>'
      })
      table += '</tbody>'

      const uri = 'data:application/vnd.ms-excel;base64,'
      const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table><tr><td>{table}</td></tr></table></body></html>'
      const base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      }
      const format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p]
        })
      }
      const ctx = {
        worksheet: `Reabilitare export ${this.selectedAPLName} ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}`,
        table
      }
      const link = document.createElement('a')
      link.download = `Reabilitare export ${this.selectedAPLName} ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}.xlsx`
      link.href = uri + base64(format(template, ctx))
      link.click()

      this.closeExportMarkers()
    }
  },

  async mounted () {
    // this.$store.dispatch('fetchStatuses')
    // this.$store.dispatch('fetchCategories')
    // this.$store.dispatch('fetchMarkers')

    try {
      const apls = await this.$store.dispatch('fetchAllAPLs')
      const statuses = await this.$store.dispatch('fetchAllStatuses')
      const categories = await this.$store.dispatch('fetchAllCategories')
      this.apls = Object.freeze(apls)
      this.statuses = Object.freeze(statuses)
      this.categories = Object.freeze(categories)
    } catch (err) {
      console.log(err)
    }
  }
}

const defaultItem = {
  _id: null,
  apl_id: null,
  status_id: null,
  category_id: null,
  unique_apl: null,
  unique: null,
  category: null,
  availability: null,
  address: null,
  lat: null,
  lng: null
}

function readFile (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = e => {
      resolve(e.target.result)
    }

    reader.onerror = event => {
      reader.abort()
      reject(new Error('file reader error'))
    }
  })
}
</script>
